import _get from 'lodash/get';

const minQueryLength = 1;

export const search = <T extends $TSFixMe>(items: T[], searchTerm: string | undefined, keys: string[]): T[] => {
    if (!searchTerm || searchTerm.length < minQueryLength) {
        return items;
    }

    const searchTermLower = searchTerm.toLocaleLowerCase();

    return items.filter((item: $TSFixMe) => {
        return keys.some(key => _get(item, key)?.toLocaleLowerCase?.()?.includes?.(searchTermLower));
    });
};
